import { graphql, useStaticQuery } from "gatsby";
import React, { useEffect, useState } from "react";
import {
  ListTestimonials as ListTestimonialsType,
  Testimonial as TestimonialType
} from "../../models/reviews/testimonial";
import Slider from "./Slider";
import Testimonial from "./Testimonial";

interface ListTestimonialsProps {
  content: ListTestimonialsType;
  width: "normal" | "wide";
}

interface AllTestimonialsQueryResult {
  allSanityTestimonial: {
    nodes: TestimonialType[];
  };
}

const ListTestimonials = ({ width, content }: ListTestimonialsProps) => {
  const data = useStaticQuery<AllTestimonialsQueryResult>(graphql`
    query AllTestimonialsQuery {
      allSanityTestimonial(sort: { _createdAt: DESC }) {
        nodes {
          _id
          _createdAt
          name
          jobPosition
          description
          tag {
            id
          }
          logo {
            asset {
              url
            }
          }
        }
      }
    }
  `);
  const allTestimonials = data.allSanityTestimonial.nodes;

  const [reviewItems, setReviewItems] = useState<TestimonialType[]>([]);

  useEffect(() => {
    if (!content) {
      return;
    }

    if (content.useLatest) {
      const contentTagsIds = content.selectedTags?.map(st => st.id) || [];
      const contentHasTags = Boolean(contentTagsIds.length);
      let relevantTestimonials = allTestimonials;

      if (contentHasTags) {
        relevantTestimonials = allTestimonials.filter(testimonial =>
          testimonial.tag?.some(tag => contentTagsIds.includes(tag.id))
        );
      }

      setReviewItems(relevantTestimonials.slice(0, content.numberOfTestimonials ?? 3));
      return;
    }

    setReviewItems(content?.selectedTestimonials ?? []);
  }, [allTestimonials, content]);

  return (
    <Slider<TestimonialType>
      width={width}
      className="reviews__slider_blue"
      items={reviewItems}
      getItemKey={item => item._id}
      renderItem={review => (
        <Testimonial
          key={review._id}
          author={review.name}
          jobPosition={review.jobPosition}
          text={review.description}
          logo={review.logo}
        />
      )}
    />
  );
};

export default ListTestimonials;

